// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"125":"component---src-pages-404-js","293":"component---src-pages-index-js"}[chunkId] + "-" + {"125":"6f2bc2fcfa3cb1eb79bf","293":"8cc9b3d7859604719be1"}[chunkId] + ".js";
};